import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';

// Services
import { CustomerRecurrenceService, MarketingEventEnumeration, MarketingEventService } from '@shared/services';
import { AuthService } from '@auth/auth.service';

//models
import { AuthenticationAndRecurrenceTypeWithNewRequestType } from './../models';

const PRODUCT_VALIDATIONS_ROUTE_CONSTANT = '/productValidations';
const HOME_ROUTE_CONSTANT = '/home';

@Injectable({
  providedIn: 'root',
})
export class AuthCasesService {
  private readonly authService: AuthService;
  private readonly marketingEventService: MarketingEventService;
  private readonly statusService: CustomerRecurrenceService;
  private readonly router: Router;

  constructor(private readonly injector: Injector) {
    this.authService = this.injector.get(AuthService);
    this.marketingEventService = this.injector.get(MarketingEventService);
    this.statusService = this.injector.get(CustomerRecurrenceService);
    this.router = this.injector.get(Router);
  }

  public execute({
    loginResponse,
    recurrenceResponse,
    newRequest,
  }: AuthenticationAndRecurrenceTypeWithNewRequestType): void {
    this.saveAccessToken(loginResponse.accessToken);
    this.statusService.saveRecurrenceStatus(recurrenceResponse.response);
    this.marketingEventService.sendMarketingEvents(MarketingEventEnumeration.LOGIN_RP);
    newRequest
      ? this.router.navigateByUrl(PRODUCT_VALIDATIONS_ROUTE_CONSTANT)
      : this.router.navigateByUrl(HOME_ROUTE_CONSTANT);
  }

  private saveAccessToken(accessToken: string): void {
    if (accessToken) {
      this.authService.saveUser(accessToken);
      this.authService.saveToken(accessToken);
    }
  }
}
